import { InsideType } from '../../constants/enum';

export const convertCodeToName = function (code) {
  // this là dùng string gốc
  switch (code) {
    case 'wardrobe_lower':
      return 'Wardrobe lower';
    case 'wardrobe_upper':
      return 'Wardrobe upper';
    case 'wardrobe_ceiling':
      return 'Wardrobe ceiling';
    case 'kitchen_lower':
      return 'Kitchen lower';
    case 'kitchen_upper':
      return 'Kitchen upper';
    case 'kitchen_ceiling':
      return 'Kitchen ceiling';
    case 'corner_lower':
      return 'Corner lower';
    case 'corner_upper':
      return 'Corner upper';
    case 'corner_ceiling':
      return 'Corner ceiling';
    case 'door-pano':
      return 'Door pano';
    case 'kitchen_upper_hood':
      return 'Range hood';
    case 'kitchen_lower_cook':
      return 'Hob cabinet';
    case 'kitchen_lower_dwash':
      return 'Dishwasher cabinet';
    case 'sink_lower':
      return 'Sink cabinet';
    case 'totl_lower':
      return 'Refrigerator cabinet';
    case 'cabinet_dry_lower':
      return 'Lower dry cabinet';
    case 'cabinet_dry_upper':
      return 'Upper dry cabinet';
    case 'cabinet_dry_ceiling':
      return 'Ceiling dry cabinet';
    case 'kitchen_corner_lower':
      return 'Lower corner cabinet';
    case 'kitchen_corner_upper':
      return 'Upper corner cabinet';
    case 'kitchen_lower_tamopbia':
    case 'wardrobe_lower_tamopbia':
    case 'shoe_lower_tamopbia':
      return 'Cover panel';
    case 'kitchen_lower_curved_block':
    case 'wardrobe_lower_curved_block':
    case 'shoe_lower_curved_block':
      return 'Lower curved block';
    case 'kitchen_upper_curved_block':
    case 'wardrobe_upper_curved_block':
    case 'shoe_upper_curved_block':
      return 'Upper curved block';
    case 'kitchen_ceiling_curved_block':
    case 'wardrobe_ceiling_curved_block':
    case 'shoe_ceiling_curved_block':
      return 'Ceiling curved block';
    case 'kitchen_corner_ceiling':
      return 'Ceiling corner cabinet';
    case 'upper_hood_present':
      return 'Existing cabinet';
    case 'kitchen_upper_mhm':
      return 'Range hood cabinet';
    case 'frame':
      return 'Frame';
    case 'door':
      return 'Door';
    case 'thicknessHau':
      return 'Back thickness';
    case 'thicknessKhung':
      return 'Frame thickness';
    case 'kitchen_lower_column':
      return 'Kitchen column cabinet';
    case 'kitchen_corner_lower_col':
      return 'Kitchen corner column cabinet';
    case 'kitchen_upper_dotke':
      return 'Wall shelf';
    case 'kitchen_ceiling_hood':
      return 'Ceiling hood cabinet';
    case 'kitchen_island_lower':
      return 'Kitchen island lower';
    case 'wardrobe_corner_lower':
      return 'Wardrobe corner lower cabinet';
    case 'wardrobe_curve_ceiling':
      return 'Wardrobe curve ceiling cabinet';
    case 'wardrobe_corner_ceiling':
      return 'Wardrobe corner ceiling cabinet';
    case 'wardrobe_col_ceiling':
      return 'Wardrobe column ceiling cabinet';
    case 'wardrobe_lower_col':
      return 'Wardrobe column lower cabinet';
    case 'lower_curved_block':
      return 'Lower curved block';
    case 'wardrobe_lower_curve':
      return 'Wardrobe lower curved cabinet';
    case 'wardrobe_lower_corner_column':
      return 'Wardrobe lower corner column cabinet';
    case 'wardrobe_lower_curved_block':
      return 'Wardrobe lower curved block';
    case 'wardrobe_upper_curved_block':
      return 'Wardrobe upper curved block';
    case 'shoe_lower_bench':
      return 'Shoe lower bench';
    case 'shoe_lower_normal':
      return 'Shoe lower normal';
    case 'shoe_ceiling_normal':
      return 'Shoe ceiling normal';
    case 'tv_lower_normal':
      return 'Tv lower normal';
    case 'tv_upper_normal':
      return 'Tv upper normal';
    case 'shoe_lower_bench_vach_guong':
      return 'Shoe lower bench with mirror louvered wall';
    case 'shoe_column_lower':
      return 'Shoe column lower cabinet';
    case 'shoe_column_ceiling':
      return 'Shoe column ceiling cabinet';
    case 'shoe_lower_bench_vach_tron':
      return 'Shoe lower bench with melamine louvered wall';
    case 'shoe_cloth_hook':
      return 'Shoe cloth hook';
    case 'shoe_lower_curved_block':
      return 'Shoe lower curved block';
    case 'shoe_upper_curved_block':
      return 'Shoe upper curved block';
    case 'decorative_lower_normal':
      return 'Decorative lower normal';
    default:
      return code;
  }
};

export const convertTypeToName = function (type) {
  switch (type) {
    case InsideType.HPANEL:
      return 'Horizontal panel';
    case InsideType.VPANEL:
      return 'Vertical panel';
    case InsideType.DRAWER:
      return 'Drawer';
    case InsideType.U_DRAWER:
      return 'U Drawer';
    case InsideType.VCURVE:
      return 'Curved vertical panel';
    case InsideType.ACCESSORY_GENERAL:
      return 'General accessory';
    case InsideType.ACCESSORY_DISH_UPPER:
      return 'Upper dish rack';
    case InsideType.ACCESSORY_DISH_LOWER:
      return 'Lower dish rack';
    case InsideType.DOOR:
      return 'Door';
    case InsideType.BRACE:
      return 'Cabinet brace';
    case InsideType.HANDLE:
      return 'Handle';
    case InsideType.VPANEL2:
      return 'Double vertical panel';
    case InsideType.CLOTHES_HANGER:
      return 'Clothes hanger rod';
    case InsideType.ACCESSORY_SINK:
      return 'Sink accessory';
    case InsideType.ACCESSORY_FRIDGE:
      return 'Refrigerator accessory';
    case InsideType.ACCESSORY_COOKER:
      return 'Induction cooktop';
    case InsideType.ACCESSORY_HOOD:
      return 'Hood accessory';
    case InsideType.ACCESSORY_FAUCET:
      return 'Faucet accessory';
    case InsideType.HPANEL_RIGHT:
      return 'Curved right horizontal panel';
    case InsideType.COL_PANEL:
      return 'Column panel';
    case InsideType.ACCESSORY_WASHER:
      return 'Dishwasher accessory';
    case InsideType.HPANEL_LEFT:
      return 'Curved left horizontal panel';
    case InsideType.DOOR_TEMPLATE:
      return 'Door template';
    case InsideType.MESH_TEMPLATE:
      return 'Mesh template';
    case InsideType.KHUNG_SAT:
      return 'Khung sat';
    default:
      return type;
  }
};

export const capitalizeWords = function (str) {
  if (str)
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
};
